"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const all_1 = require("./all");
exports.ACTIONS = {
    [all_1.TOPIC.PARSER]: all_1.PARSER_ACTION,
    [all_1.TOPIC.CONNECTION]: all_1.CONNECTION_ACTION,
    [all_1.TOPIC.AUTH]: all_1.AUTH_ACTION,
    [all_1.TOPIC.EVENT]: all_1.EVENT_ACTION,
    [all_1.TOPIC.RECORD]: all_1.RECORD_ACTION,
    [all_1.TOPIC.RPC]: all_1.RPC_ACTION,
    [all_1.TOPIC.PRESENCE]: all_1.PRESENCE_ACTION,
    [all_1.TOPIC.LOCK]: all_1.LOCK_ACTION,
    [all_1.TOPIC.STATE_REGISTRY]: all_1.STATE_ACTION,
    [all_1.TOPIC.CLUSTER]: all_1.CLUSTER_ACTION,
    [all_1.TOPIC.MONITORING]: all_1.MONITORING_ACTION
};
//# sourceMappingURL=messages.js.map